import { Box, Transition } from '@mantine/core';
import { forwardRef, CSSProperties } from 'react';
import { useReducedMotion } from '../hooks';

export interface FadeInProps {
  children: React.ReactNode;
  visible?: boolean;
  duration?: number;
  delay?: number;
  timingFunction?: string;
  style?: CSSProperties;
  className?: string;
  onEnter?: () => void;
  onEntered?: () => void;
  onExit?: () => void;
  onExited?: () => void;
}

const FadeIn = forwardRef<HTMLDivElement, FadeInProps>(
  (
    {
      children,
      visible = true,
      duration = 300,
      delay = 0,
      timingFunction = 'ease',
      style,
      className,
      onEnter,
      onEntered,
      onExit,
      onExited,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const actualDuration = reducedMotion ? 0 : duration;

    return (
      <Transition
        mounted={visible}
        transition="fade"
        duration={actualDuration}
        timingFunction={timingFunction}
        onEnter={onEnter}
        onEntered={onEntered}
        onExit={onExit}
        onExited={onExited}
      >
        {(transitionStyles) => (
          <Box
            ref={ref}
            className={className}
            style={{
              ...transitionStyles,
              transitionDelay: `${delay}ms`,
              ...style,
            }}
          >
            {children}
          </Box>
        )}
      </Transition>
    );
  }
);

FadeIn.displayName = 'FadeIn';

export default FadeIn;
